import React, { Component } from "react";
import LoginInfo from "Molecules/LoginInfo"
import TextField from "Atoms/TextField";
import ClientCaptcha from "react-client-captcha";
import "react-client-captcha/dist/index.css";

let CAPTCHA;
if(sessionStorage.getItem('app_info')){
	CAPTCHA  = JSON.parse(global.sessionStorage.getItem('app_info')).CAPTCHA;
}


export default class LoginForm extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			hasZipErrorBool: false,
			accountNumber: "",
			hasAccountNumberErrorBool: false,
			accountNumberErrorMsg: "",
			zip: "",
			zipErrorMsg: "",
			errorMessageHTML: "",
			captchaCode: "",
			errorBlock: false
		};
	}
	
	setCode = cCode => {
		this.setState({ captchaCode : cCode });
	
	  }

	accountNumberHandler = e => {
		this.setState({
			accountNumber: e.target.value
		});

	}

	zipHandler = e => {
		this.setState({
			zip: e.target.value
		});
	}

	

	playAudio = (event) => {
		event.preventDefault();
		const ccode=this.state.captchaCode
		let audioStr="";
		for(let i=0;i<ccode.length;i++){
			if(i!==0)	audioStr+=" ";
			if(ccode[i]>='a' && ccode[i]<='z')	audioStr+="small ";
			else if(ccode[i]>='A' && ccode[i]<='Z')	audioStr+="capital ";
			else	audioStr+="numeric ";
			audioStr+=ccode[i];
		}
		try{
			const audio= new SpeechSynthesisUtterance(audioStr);
			audio.rate=0.3;
			window.speechSynthesis.speak(audio);
		}catch(err){}
	}

	checkForInputErrors = (accountNotFoundErrBool, accountNotFoundMessage) => {

		const { error, message } = this.props;
		const { hasAccountNumberErrorBool, hasZipErrorBool } = this.state;
		let errHTML = null;


		if(error && message){
			errHTML = (
				<div tabIndex={1} className="login-error" role="alert">{message}</div>
			)

		}


		if (accountNotFoundErrBool || error) {
			errHTML = (
				<div tabIndex={1} className="login-error" role="alert">{accountNotFoundMessage}</div>
			)
			this.setState({ errorMessageHTML: errHTML });
			this.setState({errorBlock: true});

		}
		else if (hasAccountNumberErrorBool && hasZipErrorBool) {
			errHTML = (
					<div tabIndex={1} className="login-error" role="alert">Something seems amiss with both of these entries. Please take a look at each field, and try again, thanks!</div>
			)
			this.setState({ errorMessageHTML: errHTML });
			this.setState({errorBlock: true});

		}

		else if (hasAccountNumberErrorBool) {
			errHTML = (
				<div tabIndex={1} className="login-error" role="alert">Sorry, this Billing Account Number is invalid. <span style={{"display":"inline-block"}}>Please input a 13-digit number.</span></div>
			)
			this.setState({ errorMessageHTML: errHTML });
			this.setState({errorBlock: true});

		}
		else if (hasZipErrorBool) {
			errHTML = (
				<div tabIndex={1} className="login-error" role="alert">Sorry, this U.S. Billing Zip Code doesn’t seem to be working.</div>
			)
			this.setState({ errorMessageHTML: errHTML });
			this.setState({errorBlock: true});

		}
		else {
			errHTML = (
				<div />
			)
			this.setState({ errorMessageHTML: errHTML });
			this.setState({errorBlock: false});
		}
	}

	componentWillReceiveProps(props){
		if (props.error) {
			this.checkForInputErrors(props.error, props.errorMessage)
		}
	}

	checkAccountNumber = () => {
		const { billingAccountLength } = this.props;
		let hasAccountNumberError =
			this.state.accountNumber.length < billingAccountLength &&
			this.state.accountNumber.length > 0
				? true
				: false;
		this.setState({
			hasAccountNumberErrorBool: hasAccountNumberError
		}, () => this.checkForInputErrors());

	}

	//Need to Change: Preferably user refs
	componentDidMount() {
		window.onload = () => {
			document.getElementById("billing-account").value="";
			document.getElementById("zip").value="";
			if(CAPTCHA==="YES")	document.getElementById("retryButton").type= "button";

		}

		

	}

	submitHandler = (e) => {
		e.preventDefault()
		this.props.submitHandler({
			accountNumber: this.state.accountNumber,
			zip: this.state.zip,
			cCode: this.state.captchaCode
		})
	}

	keyUp = (e) => {	
		console.log("tooltip",e.keyCode);	
		if(e.keyCode===13){	
			this.props.toggleBox();	
		}	
	}

	checkZip = () => {
		const { zipCodeLength } = this.props;
		let hasZipError =
			this.state.zip.length < zipCodeLength && this.state.zip.length > 0
				? true
				: false;
		this.setState({
			hasZipErrorBool: hasZipError
		}, () => this.checkForInputErrors());

	}
  
	

	render() {
		return (
			<form className="LoginForm max-width-5 has-error" onSubmit={this.submitHandler}>
				<div className="dx-col">
					<div className="item">
						<div className="form-input-default has-tooltip" autoComplete="off">
							<TextField
								autoComplete="off"
								id="billing-account"
								maskType="accountNumber"
								placeholder="Billing Account Number"
								onChangeHook={this.accountNumberHandler}
								hasError={this.state.hasAccountNumberErrorBool}
								errorMessage={this.state.accountNumberErrorMsg}
								onBlurHandler={this.checkAccountNumber}
			          aria-describedby="tip-billing-acct-number"
							/>
						<div id="billing-help-trigger"	
								className="form-tooltip-trigger" tabIndex="0"	
								onKeyUp={(e)=>{this.keyUp(e)}}	
								onClick={this.props.toggleBox}>
									<svg aria-labelledby="helpIconId"
										width="30"
										height="30"
										viewBox="0 0 30 30"
										xmlns="http://www.w3.org/2000/svg">
										<title id="helpIconId">Billing Account Number Help Button</title>
										<path d="M15 30C6.716 30 0 23.284 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zM9 10.983c0 .366.153.706.459 1.02.306.314.682.471 1.127.471.755 0 1.101-.449 1.371-1.348.382-1.272 1.05-1.73 1.365-1.99.46-.379 1.099-.62 1.973-.62.748 0 1.358.218 1.83.655.474.437.71.974.71 1.61a1.83 1.83 0 0 1-.233.906 3.42 3.42 0 0 1-.572.757c-.226.226-.701.479-1.211.924-.58.509-1.041.947-1.383 1.317-.342.37-.616.799-.822 1.288-.207.489-.31 1.067-.31 1.735 0 .532.058 1.017.34 1.287.28.27.655.416 1.043.406.795 0 1.101-.414 1.252-1.24.029-.382.029-.674.071-.817.001-.143.105-.644.185-.799.128-.226.278-.44.447-.637.163-.187.536-.632 1.068-1.026.51-.315 1.386-.731 1.74-1.031.377-.37.787-.809 1.061-1.318.274-.508.411-1.1.411-1.776 0-.858-.241-1.654-.721-2.384-.481-.732-1.163-1.31-2.045-1.735C17.274 6.213 16.257 6 15.104 6c-1.24 0-2.325.254-3.255.763-.93.509-1.637 1.151-2.122 1.925-.485.775-.727 1.54-.727 2.295zM14.937 24h-.001a1.81 1.81 0 0 0 1.24-.477c.358-.318.537-.755.537-1.311 0-.501-.171-.922-.513-1.264a1.715 1.715 0 0 0-1.263-.513c-.509 0-.938.171-1.288.513-.35.342-.525.763-.525 1.264 0 .564.181 1.003.543 1.318.35.309.803.477 1.27.47z" />
									</svg>
							</div>
							{this.props.loginInfo && <div className="loginBox support-info-is-visible">	
								<LoginInfo closeBox={this.props.toggleBox}/>	
							</div>}
						</div>
					</div>
					<div className="item">
						<div className="form-input-default" autoComplete="off">
							<TextField
								autoComplete="off"
								id="zip"
								maskType="zip"
								placeholder="U.S. Billing Zip Code"
								onChangeHook={this.zipHandler}
								hasError={this.state.hasZipErrorBool}
								errorMessage={this.state.zipErrorMsg}
								onBlurHandler={this.checkZip}
							/>
						</div>
					</div>
					{CAPTCHA==="YES" && <div style={{display:"flex",alignItems:"center",justifyContent:"center"}} className="item login-form-buttons">
						<ClientCaptcha backgroundColor="#0057B8" fontColor="white" captchaCode={this.setCode} id="system_captcha"/>
						 <button style={{ 
    backgroundColor: "transparent",
    backgroundRepeat: "no-repeat",
    border: "none",
    cursor: "pointer",
    overflow: "hidden",
    outline: "none",
}} onClick={this.playAudio}><img alt="speak" height="24px" width="24px" src="/media/icons/speakerIcon.png"/></button> 
					 </div>}

				{CAPTCHA==="YES" && <div className="item login-form-buttons captchaInputDiv">
					<input placeholder="Enter text shown above" id="user_captcha_input" name="user_captcha_input" type="text" autoComplete="off"></input>
				</div>}
				  { this.state.errorBlock ? <div className="form-error-text" >{this.state.errorMessageHTML}</div> : null }
					<div className="item login-form-buttons">
						<button  type="submit" 
						  tabIndex={0}
							className="gold"
							onClick={() => {
								this.props.submitHandler(
									this.state.accountNumber,
									this.state.zip,
									this.state.captchaCode
								);
							}}>
							Continue
						</button>
					</div>
					<div className="agree-to-terms">
					  By pressing continue you agree to the <a tabIndex={0} href="/terms">terms of use</a>.
					</div>
				</div>
			</form>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/atomic/pages/LoginPage/children/LoginForm.js